// export const host = "https://unite-mern.herokuapp.com";
// export const host = "http://localhost:8000"
export const host = "https://unitechat-app-backend.onrender.com"
export const registerRoute = `${host}/api/auth/register`;
export const loginRoute = `${host}/api/auth/`;
export const setAvatarRoute = `${host}/api/auth/setAvatar`;

export const allUsersRoute = `${host}/api/auth/allUsers`;

export const sendMessageRoute = `${host}/api/messages/addmsg`;

export const getMessageRoute = `${host}/api/messages/getmsg`;
